import { useNavigate } from "react-router-dom";
import imgToUse from "../../../assets/gif/confirm-sign-up.gif";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import RazorModal from "../../../components/razor-reuse/modal/RazorModal";
import RazorInputField from "../../../components/razor-reuse/inputField/RazorInputField";

interface myComponentProps {
  visible?: boolean;
  onClose?: () => void;
}

const ConfirmSignUpModal = ({ visible, onClose }: myComponentProps) => {
  const navigate = useNavigate();
  return (
    <>
      <RazorModal
        dontShowClose
        outerClose
        visible={visible}
        onClose={onClose}
        onBtnClick={() => {}}
      >
        <div className="auth-confirm-signup-screen-modal-wrap">
          <div className="gif-box">
            <figure className="img-box">
              <img src={imgToUse} alt="" className="img" />
            </figure>
          </div>
          <p className="text">
            Your password has been successfully <br /> saved to SmartSend
          </p>
          <RazorInputField
            color={`black-light`}
            value="Proceed to Login"
            type="submit"
            className="btn"
            onSubmit={() => {
              navigate(ALL_ROUTES?.LOGIN);
            }}
          />
        </div>
      </RazorModal>
    </>
  );
};

export default ConfirmSignUpModal;
